import { setDisplayErrorSnackBar } from "../../../../features/userSlice";
import { pageSpeedPerformanceService } from "../../../../services/api/page-speed-performance.endpoints";
import store from "../../../../store";

async function getDashboadExecuteQueries(
  oauthTokenHeader: string,
  website_shared_uid: string,
  start_date: any,
  end_date: any,
  QUERY_ID: any,
  device: any
): Promise<{ id: any; data: any[] } | null> {
  try {
    const response = await pageSpeedPerformanceService.getDashboadExecuteQuery(
      oauthTokenHeader,
      website_shared_uid,
      start_date,
      end_date,
      QUERY_ID,
      device
    );

    if (!response?.status || response.status !== 200) {
      throw new Error(
        response?.parsedText || response?.statusText || "Unknown error occurred"
      );
    }
    const queryOutput = response?.data?.data?.query_output ?? [];
    return { id: QUERY_ID, data: queryOutput };
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || e?.message || "Unknown error occurred",
        type: "error",
      })
    );
    throw e;
  }
}

export const PageSpeedPerformanceDashboardEndPointLogic = {
  getDashboadExecuteQueries,
};
